import { resolveOrNull } from "@/shared/lib/async-result";
import { searchRepository } from "../../data/repositories/search.repository";
import type { SearchParams, SearchResultsResponse, SearchSuggestResponse } from "../../types";

/**
 * Server-side search used by App Router pages (e.g. a /search route).
 * Returns null on failure so the page can render an empty state instead
 * of throwing.
 */
export async function getSearchResults(
  params: SearchParams,
): Promise<SearchResultsResponse | null> {
  // A filter-only healer listing call passes `type: "healers"` with no free
  // text query — that's valid and should not be blocked. Free-text search
  // (or any other type) still requires a minimum query length.
  if (params.type !== "healers" && (!params.q || params.q.trim().length < 2)) {
    return null;
  }

  return resolveOrNull(() => searchRepository.getResults(params));
}

/** Server-side suggestions helper. */
export async function getSearchSuggestions(
  q: string,
  limit?: number,
): Promise<SearchSuggestResponse | null> {
  if (!q || q.trim().length < 2) {
    return null;
  }

  return resolveOrNull(() => searchRepository.getSuggestions(q, limit));
}
